import { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import PageLayout from "./common/PageApp";
import { getJobsDetails, applyJob } from "../../service/api";
import { toast } from "react-toastify";

const JobseekerJobDetails = () => {
  const { jobId } = useParams();
  const [jobDetails, setJobDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [btnloading, setBtnLoading] = useState(false);

  // Fetch job details
  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        setLoading(true);
        const res = await getJobsDetails({ jobId });
        console.log(res);
        setJobDetails(res.data.data);
      } catch (err) {
        console.error("Error fetching job details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobDetails();
  }, [jobId]);

  const navigate = useNavigate();
  const handleApply = async (jobId) => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token) {
      navigate("/jobseeker/login", {
        state: { from: window.location.pathname },
      });
      return;
    }

    if (role !== "job_seeker") {
      toast.error("Only jobseekers can apply for jobs!");
      return;
    }

    try {
      setBtnLoading(true);
      const res = await applyJob({ jobPostId: jobId });
      toast.success(res.data.message || "Job applied successfully!");
    } catch (err) {
      toast.error(
        err.response?.data?.message || err.message || "Failed to apply for job."
      );
    } finally {
      setBtnLoading(false);
    }
  };
  

  if (loading)
    return (
      <PageLayout>
        <p>Loading...</p>
      </PageLayout>
    );
  if (!jobDetails)
    return (
      <PageLayout>
        <p>Job not found.</p>
      </PageLayout>
    );

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <a href="javascript:void(0)">Job List</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Job Details</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="astroDetails pt-40 pb-40">
        <div className="site-width">
          <div className="row">
            {/* Left Sidebar */}
            <div className="col-md-4">
              <div className="astroSider">
                <div className="astrocard ondetails">
                  <div className="astrocContainer">
                    <div className="astrohead">
                      <div className="astroImg">
                        <a href="javascript:void(0)">
                          <img
                            src={
                              jobDetails.companyImage ||
                              "/assets/img/company-profiles/image-1.png"
                            }
                            alt="img"
                          />
                        </a>
                      </div>
                      <div className="astroName">
                        <h4>
                          {jobDetails.jobTitle}{" "}
                          <img
                            src="/assets/img/icons/icon-bold.svg"
                            className="verifiedCheck"
                            alt="icon"
                          />
                        </h4>
                        <ul className="astroAcheiver companyName">
                          <li>
                            <img
                              src="/assets/img/icons/office.svg"
                              width="20"
                              alt="icon"
                            />
                            <p>{jobDetails.company}</p>
                          </li>
                        </ul>
                      </div>
                    </div>

                  <div className="astrolBtns flex-wrap">
                    {jobDetails.skills?.map((skill, idx) => (
                      <a
                        key={idx}
                        href="javascript:void(0)"
                        className="astrocatbadge"
                      >
                        {skill}
                      </a>
                    ))}
                  </div>

                    <div className="astroDetails">
                      <div className="astroinfo">
                        <li>
                          <img
                            src="/assets/img/icons/location-.svg"
                            alt="icon"
                          />
                          <span>
                            {jobDetails.city}, {jobDetails.state}
                          </span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/calender.svg"
                            alt="icon"
                          />
                          <span>{jobDetails.jobPosted}</span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/newicon/salarytype.png"
                            alt="icon"
                          />
                          <span>
                            ₹{jobDetails.minSalary} - ₹{jobDetails.maxSalary} (
                            {jobDetails.salaryType})
                          </span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/newicon/category.png"
                            alt="icon"
                          />
                          <span>{jobDetails.category}</span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/newicon/industry.png"
                            alt="icon"
                          />
                          <span>{jobDetails.industryType}</span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/newicon/jobtype.png"
                            alt="icon"
                          />
                          <span>{jobDetails.jobType}</span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/newicon/experience.png"
                            alt="icon"
                          />
                          <span>{jobDetails.experience}</span>
                        </li>
                        <li>
                          <img
                            src="/assets/img/icons/newicon/shift.png"
                            alt="icon"
                          />
                          <span>{jobDetails.workingShift} Shift</span>
                        </li>
                      </div>
                    </div>
                  </div>

                  <div className="astrolBtns ondetails justify-content-between">
                    {/* Replace below with your auth logic */}
                    <button
                      onClick={() => handleApply(jobDetails._id)}
                      style={{
                        backgroundColor: "#270b79",
                        color: "#ffffff",
                        fontSize: "16px",
                        padding: "10px 15px",
                        borderRadius: "25px",
                        border: "none",
                      }}
                      disabled={btnloading}
                    >
                      {btnloading ? (
                        <span>
                          <i
                            className="fa fa-spinner fa-spin"
                            style={{ marginRight: "8px" }}
                          ></i>
                          Applying...
                        </span>
                      ) : (
                        "Apply Now"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-md-8">
              <div className="astroDetailsWrap">
                <div className="navWrapper">
                  <ul className="navcontaienr gap-2 d-flex flex-wrap">
                    <li>
                      <a
                        className="navibtn active"
                        data-target="#Information"
                        href="#Information"
                      >
                        Job Details
                      </a>
                    </li>
                    <li>
                      <a
                        className="navibtn"
                        data-target="#aboutCompany"
                        href="#aboutCompany"
                      >
                        About Company
                      </a>
                    </li>
                  </ul>
                </div>

                {/* Job Details Tab */}
                <div className="sectionTop tabContentBox" id="Information">
                  <div className="wrapper mt-4">
                    <h4 className="titletwo">Job Information</h4>
                    <div
                      className="content"
                      dangerouslySetInnerHTML={{
                        __html: jobDetails.jobDescription,
                      }}
                    />
                  </div>
                </div>

                {/* About Company Tab */}
                <div className="sectionTop tabContentBox" id="aboutCompany">
                  <div className="wrapper mt-4">
                    <h4 className="titletwo">About Company</h4>
                    <div
                      className="content"
                      dangerouslySetInnerHTML={{
                        __html: jobDetails.aboutCompany,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default JobseekerJobDetails;
